import moment from 'moment'

export const PatientOrthoSpace = {
    id: '',
    patientId: '',
    patientName: '',
    patientAddress: '',
    patientAge: 0,
    ra: 0,
    medianLineTL: 0,
    medianLineTR: 0,
    lackOfSpaceTL: 0,
    lackOfSpaceTR: 0,
    bendLengthTL: 0,
    bendLengthTR: 0,
    sumOfMesiodistalTL: 0,
    sumOfMesiodistalTR: 0,
    bendLength1TL: 0,
    bendLength2TL: 0,
    bendLength1TR: 0,
    bendLength2TR: 0,
    mesiodistal1TL: 0,
    mesiodistal2TL: 0,
    mesiodistal1TR: 0,
    mesiodistal2TR: 0,
    teeth1TL: '',
    teeth2TL: '',
    teeth3TL: '',
    teeth4TL: '',
    teeth5TL: '',
    teeth6TL: '',
    teeth7TL: '',
    teeth8TL: '',
    teeth1TR: '',
    teeth2TR: '',
    teeth3TR: '',
    teeth4TR: '',
    teeth5TR: '',
    teeth6TR: '',
    teeth7TR: '',
    teeth8TR: '',
    teeth1BL: '',
    teeth2BL: '',
    teeth3BL: '',
    teeth4BL: '',
    teeth5BL: '',
    teeth6BL: '',
    teeth7BL: '',
    teeth8BL: '',
    teeth1BR: '',
    teeth2BR: '',
    teeth3BR: '',
    teeth4BR: '',
    teeth5BR: '',
    teeth6BR: '',
    teeth7BR: '',
    teeth8BR: '',
    mesiodistal1BL: 0,
    mesiodistal2BL: 0,
    mesiodistal1BR: 0,
    mesiodistal2BR: 0,
    bendLength1BL: 0,
    bendLength2BL: 0,
    bendLength1BR: 0,
    bendLength2BR: 0,
    sumOfMesiodistalBL: 0,
    sumOfMesiodistalBR: 0,
    bendLengthBL: 0,
    bendLengthBR: 0,
    lackOfSpaceBL: 0,
    lackOfSpaceBR: 0,
    medianLineBL: 0,
    medianLineBR: 0,

    createdBy : '',
    updatedBy : '',
    createdAt : moment().format('YYYY-MM-DD'),
    updatedAt : moment().format('YYYY-MM-DD'),
}